import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./LoginPage.module.css";
import { loginApi } from "../http/http";
import { setAuthSession, isAuthenticated } from "../util/auth";

const LoginPage = () => {
  const navigate = useNavigate();

  const [msisdn, setMsisdn] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (isAuthenticated()) {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  const resetMessages = () => {
    setMessage("");
    setError("");
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    resetMessages();
    setLoading(true);

    try {
      const result = await loginApi({ msisdn });
      const { token, user } = result.data || {};
      if (!token) throw new Error("Login token missing");
      setAuthSession(token, user);
      setMessage("Login successful. Redirecting to home...");
      setTimeout(() => navigate("/", { replace: true }), 800);
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className={classes.main}>
      <div className={classes.card}>
        <button
          type="button"
          className={classes.backBtn}
          onClick={() => navigate("/")}
        >
          Back to Home
        </button>

        <h1 className={classes.title}>Login to Kids Plex</h1>
        <p className={classes.subtitle}>
          Enter your subscribed mobile number to continue.
        </p>

        <form className={classes.form} onSubmit={handleLogin}>
          <label className={classes.label} htmlFor="login-msisdn">
            MSISDN
          </label>
          <input
            id="login-msisdn"
            type="tel"
            className={classes.input}
            placeholder="08167453846"
            value={msisdn}
            onChange={(event) => setMsisdn(event.target.value)}
            required
          />

          <button
            type="submit"
            className={classes.primaryBtn}
            disabled={loading || !msisdn}
          >
            {loading ? "Checking..." : "Login"}
          </button>
        </form>

        {message && <p className={classes.success}>{message}</p>}
        {error && <p className={classes.error}>{error}</p>}

        <div className={classes.footerLinks}>
          <button
            type="button"
            className={classes.linkBtn}
            onClick={() => navigate("/subscribe")}
          >
            Not subscribed yet? Subscribe
          </button>
        </div>
      </div>
    </main>
  );
};

export default LoginPage;
